var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ph:plus"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14 8.28711C14 8.41972 13.9473 8.5469 13.8536 8.64066C13.7598 8.73443 13.6326 8.78711 13.5 8.78711H8.5V13.7871C8.5 13.9197 8.44732 14.0469 8.35355 14.1407C8.25979 14.2344 8.13261 14.2871 8 14.2871C7.86739 14.2871 7.74021 14.2344 7.64645 14.1407C7.55268 14.0469 7.5 13.9197 7.5 13.7871V8.78711H2.5C2.36739 8.78711 2.24021 8.73443 2.14645 8.64066C2.05268 8.5469 2 8.41972 2 8.28711C2 8.1545 2.05268 8.02732 2.14645 7.93356C2.24021 7.83979 2.36739 7.78711 2.5 7.78711H7.5V2.78711C7.5 2.6545 7.55268 2.52732 7.64645 2.43356C7.74021 2.33979 7.86739 2.28711 8 2.28711C8.13261 2.28711 8.25979 2.33979 8.35355 2.43356C8.44732 2.52732 8.5 2.6545 8.5 2.78711V7.78711H13.5C13.6326 7.78711 13.7598 7.83979 13.8536 7.93356C13.9473 8.02732 14 8.1545 14 8.28711Z",
    fill: "#DEDEDE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhPlus);
export default __webpack_public_path__ + "static/media/ph_plus.4d1463eff63843229ed77c4052024e52.svg";
export { ForwardRef as ReactComponent };